export default "__VITE_ASSET__DZ15aokr__"